import Phaser from 'phaser'

import './style.css'
import { BootScene } from './scenes/BootScene'
import { MenuScene } from './scenes/MenuScene'
import { IntroScene } from './scenes/IntroScene'
import { GameScene } from './scenes/GameScene'

const orientationOverlay = document.getElementById('orientation-overlay')

const prefersLandscape = window.matchMedia('(orientation: landscape)')

const shouldShowOverlay = (width: number, height: number) => {
  const isMobile = Math.min(width, height) <= 900
  const isLandscape = width >= height
  return isMobile && !isLandscape
}

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  backgroundColor: '#1d1d1d',
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: window.innerWidth,
    height: window.innerHeight,
  },
  scene: [BootScene, MenuScene, IntroScene, GameScene],
}

export const game = new Phaser.Game(config)

const setViewportMeta = (): void => {
  const existing = document.querySelector('meta[name="viewport"]') as HTMLMetaElement | null
  const viewportContent = 'width=device-width, height=device-height, initial-scale=1, maximum-scale=1, viewport-fit=cover'

  if (existing) {
    existing.setAttribute('content', viewportContent)
  } else {
    const meta = document.createElement('meta')
    meta.name = 'viewport'
    meta.content = viewportContent
    document.head.appendChild(meta)
  }
}

setViewportMeta()

const rootElement = document.documentElement

const updateViewportHeight = (): void => {
  const viewport = 'visualViewport' in window ? (window.visualViewport as VisualViewport) : undefined
  const height = viewport?.height ?? window.innerHeight
  rootElement.style.setProperty('--app-viewport-height', `${height}px`)
}

updateViewportHeight()
window.addEventListener('resize', updateViewportHeight)
window.addEventListener('orientationchange', updateViewportHeight)

if ('visualViewport' in window) {
  const visualViewport = window.visualViewport as VisualViewport
  visualViewport.addEventListener('resize', updateViewportHeight)
  visualViewport.addEventListener('scroll', updateViewportHeight)
}

const resizeGame = () => {
  const width = window.innerWidth
  const height = window.innerHeight

  game.scale.resize(width, height)

  if (shouldShowOverlay(width, height)) {
    orientationOverlay?.classList.add('active')
  } else {
    orientationOverlay?.classList.remove('active')
  }
}

resizeGame()

prefersLandscape.addEventListener('change', resizeGame)
window.addEventListener('resize', resizeGame)

document.addEventListener('visibilitychange', () => {
  if (!document.hidden) {
    resizeGame()
  }
})
